import React, { useCallback } from 'react';
import { Button, Flex, Toast } from '@leverege/ui-elements';
import { ValueText, LabelText, Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { RECOVR_HOTLINE_NUMBER } from '../../../../constants';
import S from './TheftRecovery.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CaseData(props) {
  const {
    caseData,
    caseActions
  } = props;
  const caseId = Attributes.get('case.caseId', caseData);
  const accessCode = Attributes.get('case.accessCode', caseData);
  const url = `${process.env.THEFT_RECOVERY_URL}?caseId=${caseId}&accessCode=${accessCode}`;
  const onCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(`https://${url}`);
      Toast.success('Copied url to clipboard.');
    } catch (err) {
      console.error(err);
      Toast.error(['Error copying url to clipboard.', err.message]);
    }
  }, [url]);
  const onClick = useCallback(() => {
    const id = caseActions.id;
    GlobalState.dispatch(caseActions.parent().goTo(id));
  }, [caseActions]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Flex, {
      justify: "space-between",
      align: "center",
      className: S.even,
      children: [/*#__PURE__*/_jsx(LabelText, {
        className: S.label,
        children: "Case Number"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "link",
        onClick: onClick,
        className: S.value,
        children: caseId
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      justify: "space-between",
      align: "center",
      className: S.odd,
      children: [/*#__PURE__*/_jsx(LabelText, {
        className: S.label,
        children: "Access Code"
      }), /*#__PURE__*/_jsx(ValueText, {
        className: S.value,
        children: accessCode
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      justify: "space-between",
      align: "center",
      className: S.even,
      children: [/*#__PURE__*/_jsx(LabelText, {
        className: S.label,
        children: "Theft Recovery URL"
      }), caseId ? /*#__PURE__*/_jsxs(Flex, {
        className: S.flex,
        align: "center",
        children: [/*#__PURE__*/_jsx("a", {
          className: S.link,
          target: "_blank",
          href: `https://${url}`,
          rel: "noreferrer",
          children: url
        }), /*#__PURE__*/_jsx(Button, {
          className: S.copy,
          variant: "link",
          onClick: onCopy,
          imageOpts: {
            height: '24px',
            width: '24px'
          },
          icon: "https://recovr-ui-assets.storage.googleapis.com/icon-copy.png"
        })]
      }) : null]
    }), /*#__PURE__*/_jsxs(Flex, {
      justify: "space-between",
      align: "center",
      className: S.odd,
      children: [/*#__PURE__*/_jsx(LabelText, {
        className: S.label,
        children: "RecovR Hotline"
      }), /*#__PURE__*/_jsx("a", {
        className: S.hotline,
        href: `tel:${RECOVR_HOTLINE_NUMBER}`,
        rel: "noreferrer",
        children: RECOVR_HOTLINE_NUMBER
      })]
    })]
  });
}
export default /*#__PURE__*/React.memo(CaseData);